if ($("footer#footer").length) {
  if ($("footer#footer .customContactBox").length) {
    $("body").append($("footer#footer .customContactBox"));
  }

  if ($("footer#footer .customSlideBanner").length) {
    $("body").append($("footer#footer .customSlideBanner"));
  }

  $(".copyright").html($(".copyright").html().replace("Copyright", "Copyright 2010 - "));
  $("footer#footer").after($(".footer-bottom").removeClass(".container").wrapInner('<div class="container"></div>'));
  $("footer#footer").after($(".footer-links-icons"));
  $("#signature").removeAttr("style").append($("footer#footer .signature"));
  $("footer#footer .newsletterForm").append($("footer#footer #formNewsletterWidget"));
  $(document).on("click", ".custom-footer>div h4", function () {
    $(this).closest(".custom-footer>div").toggleClass("openIt");
  });

  $("footer#footer .logoSocial ul.customSocialIcon").append($("footer#footer .contact-box li span.facebook").closest("li").clone());
  $("footer#footer .logoSocial ul.customSocialIcon").append($("footer#footer .contact-box li span.instagram").closest("li").clone());
  $("footer#footer .logoSocial ul.customSocialIcon").append($("footer#footer .contact-box li span.tiktok").closest("li").clone());
  $("footer#footer .logoSocial ul.customSocialIcon").append($("footer#footer .contact-box li span.youtube").closest("li").clone());

  $("footer#footer .customContact").prepend($("footer#footer .contact-box li span.mail").closest("li").clone().addClass("email"));
  $("footer#footer .customContact").prepend($("footer#footer .contact-box li span.tel").closest("li").clone().addClass("telephone"));
  $(".mobileSuNavigation .inner a.cartCustom i").remove();
  $(".mobileSuNavigation .inner a.cartCustom").append($('a[data-target="cart"] i').clone());
  $("footer#footer").after($("footer#footer .mobileSuNavigation"));

  if ($(".in-index").length) {
    $("#footer .custoBlog .homepage-group-title.h4").text(translation("blogNadpis"));
    $("#footer .custoBlog .container>.btn").text(translation("vsechnyClanky"));
    $("#footer").before($(".custoBlog").clone());
  }

  $("footer#footer").before($("footer#footer .customReviews"));

  $("footer#footer").before($("footer#footer .instagramFeed"));
  $(".instagram-widget>a").each(function () {
    $(".instagramFeed .igFeed").append('<div class="igPost"><a href="' + $(this).attr("href") + '" target="_blank" style="background-image: url(' + $(this).find("img").attr("data-src") + ')"></a></div>');
  });
  $("footer#footer .newsletterForm form button[type=submit]").text(translation("odebiratNovinky"));
  $('footer#footer .newsletterForm form input[type="email"]').attr("placeholder", translation("vasEmail"));
  $("#customerLogin").prepend('<div class="registerPlus">' + registrationBenefits + "</div>");
  $(".top-navigation-bar .container").append($("footer#footer #shippingCountdown"));
  $(".top-navigation-tools").append('<div class="languageSwitcher"><span>' + translation("jazykShopu") + "</span><ul></ul></div>");
  const $list = $("#shippingCountdown .shippingList");
  $.each(shippingTimes, function (carrier, time) {
    $list.append(`<li><strong>${carrier}</strong> <span class="time" data-deadline="${time}"></span></li>`);
  });
  updateCountdown();
  setInterval(updateCountdown, 60000);
  initLanguageSwitcher(languages);
} else {
  $(document).ready(function () {
    if (sessionStorage.loadedFooter) {
      $(".overall-wrapper").append('<footer id="footer">' + sessionStorage.loadedFooter + "</footer>");
      customHeader();
    } else {
      $.ajax({
        type: "GET",
        dataType: "html",
        timeout: 1e4,
        cache: !0,
        url: "/",
        success: function (e) {
          var a = shoptet.common.createDocumentFromString(e),
            t = $(a).find("footer#footer").html();
          null !== t && $(".overall-wrapper").append('<footer id="footer">' + t + "</footer>");
          sessionStorage.loadedFooter = $("footer#footer").html();
          customHeader();
        },
      });
    }
  });
}

function customHeader() {
  $("#customerLogin").prepend('<div class="registerPlus">' + registrationBenefits + "</div>");
  $(".top-navigation-bar .container").append($("footer#footer #shippingCountdown"));
  $(".top-navigation-tools").append('<div class="languageSwitcher"><span>' + translation("jazykShopu") + "</span><ul></ul></div>");
  const $list = $("#shippingCountdown .shippingList");
  $.each(shippingTimes, function (carrier, time) {
    $list.append(`<li><strong>${carrier}</strong> <span class="time" data-deadline="${time}"></span></li>`);
  });
  updateCountdown();
  setInterval(updateCountdown, 60000);
  initLanguageSwitcher(languages);
}

function initLanguageSwitcher(languages) {
  const $langSwitcher = $(".languageSwitcher ul");
  $langSwitcher.empty();

  $.each(languages, function (_, lang) {
    $langSwitcher.append(`
      <li>
        <a href="${lang.url}" class="lang-btn">
          <img src="${lang.flag}" alt="${lang.name} flag" class="lang-flag" loading="lazy">
          <span class="lang-name">${lang.name}</span>
        </a>
      </li>
    `);
  });
}

$("html").on("click", ".languageSwitcher>span", function () {
  $(this).closest(".languageSwitcher").toggleClass("showLangMenu");
  $(".dropdown").removeClass("open");
});

$("html").on("click", "button#topNavigationDropdown", function () {
  $(".languageSwitcher").removeClass("showLangMenu");
});

$("html").on("click", ".newLogin", function () {
  $("body").addClass("user-action-visible login-window-visible");
});

$(document).on("click", ".customSlideBanner .arrow", function () {
  var isMobile = $("body").hasClass("mobile"); // Zjistí, jestli má body třídu .mobile
  var smallWidth = isMobile ? "56px" : "90px"; // Šířka pro zavřené zobrazení
  var largeWidth = "90%"; // Šířka pro otevřené zobrazení

  $(this).closest(".customSlideBanner").toggleClass("closeIt");
  $(this).closest(".customSlideBanner").find(".right").slideToggle(0);

  if ($(this).closest(".customSlideBanner").css("width") === smallWidth) {
    $(this).closest(".customSlideBanner").animate(
      {
        width: largeWidth,
      },
      10,
    );
    sessionStorage.setItem("infoMsgState", "openInfoMessage");
  } else {
    $(this).closest(".customSlideBanner").animate(
      {
        width: smallWidth,
      },
      500,
    );
    sessionStorage.setItem("infoMsgState", "hideInfoMessage");
  }
});

$(document).ready(function () {
  var isMobile = $("body").hasClass("mobile"); // Zjistí, jestli má body třídu .mobile
  var smallWidth = isMobile ? "56px" : "90px"; // Šířka pro zavřené zobrazení

  if (sessionStorage.getItem("infoMsgState") === "hideInfoMessage") {
    $(".customSlideBanner").addClass("closeIt"); // Nastaví třídu pro zavřené zobrazení
    $(".customSlideBanner").find(".right").slideToggle(0);
    $(".customSlideBanner").animate(
      {
        width: smallWidth,
      },
      0,
    );
  }
});

var CUSTOM_CONTACT_CLOSED_KEY = "customContactBoxClosed";

try {
  if (window.localStorage.getItem(CUSTOM_CONTACT_CLOSED_KEY) === "1") {
    $(".customContactBox").addClass("closed");
    $(".customContactBox .contactUs").show();
    $(".customContactBox .bottom").hide();
  }
} catch (e) {}

$("html").on("click", ".customContactBox .contactUs", function () {
  $(".customContactBox").removeClass("closed");
  $(".customContactBox .bottom").slideToggle();
  $(".customContactBox .close").show();
  $(".customContactBox .contactUs").hide();
  try {
    window.localStorage.removeItem(CUSTOM_CONTACT_CLOSED_KEY);
  } catch (e) {}
});

$("html").on("click", ".customContactBox .close", function () {
  $(".customContactBox").addClass("closed");
  $(".customContactBox .contactUs").show();
  $(".customContactBox .bottom").hide();
  try {
    window.localStorage.setItem(CUSTOM_CONTACT_CLOSED_KEY, "1");
  } catch (e) {}
});

$("html").on("click", ".customFloatingContact", function () {
  $(".customContactBox").slideToggle();
});

function updateCountdown() {
  const now = new Date();
  const isNightTime = now.getHours() >= 17 || now.getHours() < 8;

  $(".shippingList .time").each(function () {
    const $time = $(this);
    const $item = $time.closest("li");
    const deadlineStr = $time.data("deadline");

    // reset pomocné classy
    $item.removeClass("notToday nightTime nextPickup");

    // když není čas
    if (!deadlineStr) {
      $time.text("00 h 00 m");
      $item.addClass("notToday");

      if (isNightTime) {
        $item.addClass("nightTime");
      }

      return;
    }

    const [hours, minutes] = deadlineStr.split(":").map(Number);

    let deadline = new Date(now.getFullYear(), now.getMonth(), now.getDate(), hours, minutes, 0);

    /**
     * Pokud už dnešní svoz utekl,
     * nastavíme deadline na další den.
     */
    if (now > deadline) {
      deadline.setDate(deadline.getDate() + 1);

      // pomocná classa, že už nejde o dnešní svoz
      $item.addClass("notToday nextPickup");

      if (isNightTime) {
        $item.addClass("nightTime");
      }
    }

    const diffMs = deadline - now;

    const diffH = Math.floor(diffMs / (1000 * 60 * 60));
    const diffM = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

    const h = diffH.toString().padStart(2, "0");
    const m = diffM.toString().padStart(2, "0");

    $time.text(`${h} h ${m} m`);
  });
}
